import { api } from "@/api/api";

const getFileExtension = (url: string) => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const match = pathname.match(/\.([a-z0-9]+)$/i);
    return match ? match[1] : "png";
  } catch {
    return "png";
  }
};

export const handleDownloadImage = async (
  episodeId: string | undefined,
  onLoadStart: () => void,
  onLoadEnd: () => void,
) => {
  if (!episodeId) {
    return;
  }
  onLoadStart();
  const episodeData = await api.episodes.episodeId.get({
    episodeId,
  });
  const blob = await api.episodes.episodeId.imagesForManualEdit.get({
    episodeId: episodeData.id,
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;

  link.download = `${episodeData.story}_${
    episodeData.category
  }_${episodeData.subcategory}_${episodeData.gender}_${episodeData.id}.zip`;

  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
  onLoadEnd();
};

// this probably is never used???
export const handleDownloadMask = (maskUrl: string, maskId: string) => {
  const extension = getFileExtension(maskUrl);
  const link = document.createElement("a");
  link.href = maskUrl;
  link.download = `mask-${maskId}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
